// extracted by mini-css-extract-plugin
module.exports = {"input-container":"icibs_component_input-container__hy0uN","input-wrap":"icibs_component_input-wrap__6wlqB","card":"icibs_component_card__VoING"};